import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { initializePaddleBilling } from "../utils/paddleUtils";
import PageLayout from "../layout/PageLayout";
import "../styles.css";
import BackButton from "../components/BackButton";

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userData, opportunityId, venueId, type } = location.state || {};
  const partnerLogoUrl = location.state?.partnerLogoUrl || (typeof window !== 'undefined' ? sessionStorage.getItem('partnerLogoUrl') || undefined : undefined);
  const customUi = location.state?.customUi ?? (typeof window !== 'undefined' ? sessionStorage.getItem('customUi') === 'true' : undefined);

  useEffect(() => {
    if (!userData || !opportunityId || !venueId || !type) {
      console.error("Missing required data for payment.");
      navigate("/");
      return;
    }

    const targetContainer = document.querySelector(".checkout-container");
    if (targetContainer) {
      try {
        sessionStorage.setItem("checkoutEmail", userData?.email || "");
        sessionStorage.setItem("checkoutVenueId", venueId || "");
        sessionStorage.setItem("checkoutType", type || "");
      } catch (_) {}
      initializePaddleBilling({
        targetClassName: "checkout-container",
        userData,
        opportunityId,
        venueId,
        type,
        navigate,
      });
    } else {
      console.error("Checkout container not found.");
    }
  }, [navigate, userData, opportunityId, venueId, type]);

  return (
    <PageLayout type={type} partnerLogoUrl={partnerLogoUrl} customUi={customUi}>
      <h2>Add your payment details</h2>
      <p>
        Please provide your payment details to complete the subscription.
      </p>
      <div className="checkout-container"></div>
      <div className="payment-actions">
        <BackButton />
      </div>
    </PageLayout>
  );
};

export default PaymentPage;
